export default "__VITE_ASSET__C2pvgl1d__"